<div class="w-full flex justify-start items-center p-4">
  <i class="ico-Close cursor-pointer text-xl ml-3" (click)="dialogRef.close()"></i>
  <h3 class="text-lg" *ngIf="data.accommodation != 'ecolodge'">فاصله هتل با مراکز مهم و دسترسی ها</h3>
  <h3 class="text-lg" *ngIf="data.accommodation == 'ecolodge'">فاصله اقامتگاه با مراکز مهم و دسترسی ها</h3>
</div>
<div *ngIf="data" class="ps-6 pe-3 me-3 py-4 h-[88%] overflow-y-auto">
  <ng-container *ngIf="data?.type != 2">
    <!-- ایستگاه‌های مترو -->
    <ng-container *ngIf="data?.distance?.MetroLines?.length && data?.distance?.Airports?.length">
      <div class="w-full border-b border-solid mb-3 pb-3">
        <div class="flex justify-start items-center">
          <i class="ico-Train text-xl ml-2"></i>
          <h3 class="text-base font-bold">فاصله تا پایانه ها</h3>
        </div>
        <ng-container *ngIf="data.distance.MetroLines">
          <div *ngFor="let item of data.distance.MetroLines" class="flex w-full items-center text-black-300 mt-4">
            <div class="flex items-center flex-1 gap-2">
              <h5 class="text-sm">{{item.Name}}</h5>
            </div>
            <p class="font-extralight text-sm">{{ item.Distance }} {{
              item.DistanceUnitName }}</p>
          </div>
        </ng-container>
        <div *ngFor="let item of data.distance.Airports" class="flex w-full items-center text-black-300 mt-4">
          <div class="flex items-center flex-1 gap-2">
            <h5 class="text-sm">{{item.Name}}</h5>
          </div>
          <p class="font-extralight text-sm">{{ item.Distance }} {{
            item.DistanceUnitName }}</p>
        </div>
      </div>
    </ng-container>


    <ng-container *ngIf="data?.nearBies">
      <div class="w-full border-b border-solid mb-3 pb-3">
        <div class="flex justify-start items-center">
          <i class="ico-Location-line text-xl ml-2"></i>
          <h3 class="text-base font-bold">مکان های نزدیک </h3>
        </div>
        <div *ngFor="let item of data?.nearBies" class="flex w-full items-center text-black-300 mt-4">
          <div class="flex items-center flex-1 gap-2">
            <h5 class="text-sm">{{item?.Name}}</h5>
          </div>
          <p class="font-extralight text-sm">{{ item?.Distance }} {{ item?.DistanceUnit == 1 ? 'متر' : 'کیلومتر' }}</p>
        </div>
      </div>
    </ng-container>


    <ng-container *ngIf="data?.distance?.HolyShrines?.length || data?.distance?.DistanceList?.length">
      <div class="flex justify-start items-center">
        <i class="ico-Holyshrine text-xl ml-2"></i>
        <h3 class="text-base font-bold">مکان های مهم دیگر</h3>
      </div>
      <div *ngFor="let item of data?.distance?.HolyShrines" class="flex w-full items-center text-black-300 mt-4">
        <div class="flex items-center flex-1 gap-2">
          <h5 class="text-sm">{{item.Name}}</h5>
        </div>
        <p class="font-extralight text-sm">{{ item.Distance }} {{
          item.DistanceUnitName }}</p>
      </div>
    </ng-container>
    <div *ngFor="let item of data?.distance?.DistanceList" class="flex w-full items-center text-black-300 mt-4">
      <div class="flex items-center flex-1 gap-2">
        <h5 class="text-sm">{{item.Name}}</h5>
      </div>
      <p class="font-extralight text-sm">{{ item.Distance }} {{
        item.DistanceUnitName }}</p>
    </div>


  </ng-container>

  <ng-container *ngIf="data?.type == 2">
    <ul *ngIf="data?.distance?.DistanceList?.length" class="mt-3 w-full">
      <ng-container *ngFor="let item of data?.distance?.DistanceList;let index = index">
        <li class="grid grid-cols-2 justify-between mt-2 items-center gap-2">
          <div class="flex justify-start items-center">
            <span class="text-black-500 text-base text-start font-bold">{{item.Name}}</span>
          </div>
          <p class="font-extralight text-black-300 text-sm text-end">{{ item.Distance }} {{ item.Duration}}</p>
        </li>
      </ng-container>
    </ul>
  </ng-container>

</div>